/* eslint no-underscore-dangle: ["error", { "allow": ["_id", "_created"] }] */
import PropTypes from 'prop-types';

import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import KeyprIcon from '@keypr/icon-font';
import _ from 'lodash';

import TimeAge from '../../components/Filters/TimeAge';
import MultipleLocations from '../../components/MultipleLocations';
import DeliveryTime from '../../components/Filters/DeliveryTime';
import Priority from '../../components/Priority';
import { localize } from '../../i18n';

import './WorkorderCard.css';

class WorkorderCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  getCompletedTasks(list) {
    return list && list.reduce((total, task) => total + (task.is_completed ? 1 : 0), 0);
  }

  render() {
    const {
      workorder,
      workorderConfig,
    } = this.props;
    let forLocations = null;
    const channelColor = {
      borderLeft: '4px solid',
      borderLeftColor: workorder.dashboardColor,
    };
    const { checklist } = workorder;

    const backgroundColorChart = {
      normal: 'md-card-bg-success',
      warning: 'md-card-bg-warning',
      critical: 'md-card-bg-danger',
    };
    const ukBadge = {
      true: 'uk-badge-danger',
      false: 'uk-badge-primary',
    };

    const priorityColor = {
      0: 'uk-badge-success',
      1: 'uk-badge-warning',
      2: 'uk-badge-danger',
    };

    const cardCls = ['md-card'];
    const cardBarCls = ['md-card-toolbar'];
    const ukBadgeCls = ['uk-badge'];
    const ukBadgeClsPriority = ['uk-badge'];
    if (workorder.severity in backgroundColorChart) {
      cardCls.push(backgroundColorChart[workorder.severity]);
    }
    if (workorder.priority in priorityColor) {
      ukBadgeClsPriority.push(priorityColor[workorder.priority]);
    }
    ukBadgeCls.push(ukBadge[workorder.is_late]);

    if (workorder.locations && workorder.locations.length > 0) {
      forLocations = (
        <span>{this.props.t('for')} <MultipleLocations locations={workorder.locations} noChips /></span>
      );
    }

    const workorderDueDate = new Date(workorder.due_date).valueOf();
    const workorderCreated = new Date(workorder._created).valueOf();

    const epochs = [
        { name: 'service_window_start', value: workorderCreated },
        { name: 'service_window_end', value: workorderDueDate },
        { name: 'target', value: workorderDueDate },
        { name: 'new', value: workorderDueDate },
    ];

    workorder.epochs = epochs;
    const lateClass = workorder.is_late ? 'late' : null;

    const workOrderDetailsPage = {
      pathname: `/access/workorders/${workorder._id}/details`,
      state: { workorder, workorderConfig },
    };

    const checklistInfo = (
      <div className="uk-text-medium" style={{ visibility: checklist ? 'visible' : 'hidden' }}>
        {this.props.t('Tasks')} { checklist &&
        <span
          className="uk-badge uk-badge-danger uk-text-medium"
          style={{ fontSize: '14px' }}
        >
          {this.getCompletedTasks(checklist)}/{checklist.length}
        </span>
      }
      </div>
    );

    return (
      <div className={`uk-margin-medium-top WorkorderCard ${lateClass}`}>
        <Link to={workOrderDetailsPage} key={workorder._id}>
          <div className={cardCls.join(' ')} style={channelColor}>
            <div className={cardBarCls.join(' ')}>
              <div className="md-card-toolbar-actions">
                <div className="uk-grid">
                  <div className="uk-grid-width-medium-1-2">
                    <TimeAge time={workorder._created} />
                  </div>
                </div>
              </div>
              <h3 className="md-card-toolbar-heading-text">
                <span className="md-card-toolbar-icon"><KeyprIcon icon={workorder.icon} className="service-icon" /></span>
                <span className="md-card-toolbar-title">{workorder.label}</span>
              </h3>
            </div>
            <div className="md-card-content">
              <div className="uk-float-right uk-margin-small-right">
                <div className="uk-text-small">{this.props.t('Work Order Status')}</div>
                <div className="uk-text-nowrap uk-text-right">
                  <span className={ukBadgeCls.join(' ')}>{this.props.t(_.startCase(workorder.status))}</span>
                </div>
                <div className="uk-text-small uk-text-right">{this.props.t('Priority')}</div>
                <div className="uk-text-nowrap uk-text-right">
                  <span className={ukBadgeClsPriority.join(' ')}><Priority priority={workorder.priority} /></span>
                </div>
              </div>
              <div className="uk-text-large"><b>#{workorder.number}</b> {forLocations}</div>
              {checklistInfo}
              <DeliveryTime
                epochs={workorder.epochs}
                className="delivery-time uk-text-small"
              />
            </div>
          </div>
        </Link>
      </div>
    );
  }
}

WorkorderCard.propTypes = {
  workorder: PropTypes.shape({
    id: PropTypes.string,
  }),
  workorderConfig: PropTypes.shape({}),
  t: PropTypes.func.isRequired,
};

export default localize(WorkorderCard);



// WEBPACK FOOTER //
// ./src/views/workorders/WorkorderCard.js